import { z } from 'zod';
import {
    WidgetType,
    ZodGenericWidgetConfigurationDetails,
    ZodBaseWidgetConfiguration,
} from '../types';
import { zMarshalToBoolean, zMarshalToStrictInt } from '../../ReachApi/Marshallers';

export enum ResourceType {
    Dashboard = 'dashboard',
    Report = 'report',
}

export enum CloudType {
    General = 'general',
    Government = 'government',
}

export const ZodPowerBIWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    resource_type: z.nativeEnum(ResourceType),
    group_id: z.string(),
    resource_id: z.string(),
    tile_id: z.string(),
    filters: z.string(),
    data_refresh_interval: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
    workspace_type: z.enum(['app', 'groups']),
    app_id: z.string(),
    url_filter: z.string(),
    pages: z.string(),
    auto_page_switch: z.unknown().transform(zMarshalToBoolean),
    pages_switch_interval: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
    cloud_type: z.nativeEnum(CloudType),
});

export type PowerBIWidgetConfigurationDetails = z.infer<
    typeof ZodPowerBIWidgetConfigurationDetails
>;

export const ZodPowerBIWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.POWERBI),
    config: ZodPowerBIWidgetConfigurationDetails,
});

export type PowerBIWidgetConfiguration = z.infer<typeof ZodPowerBIWidgetConfiguration>;

export type ReportPage = {
    name: string; // Unique name
    displayName: string; // Pretty name
    order: number; // Order of the page as seen in the Power BI report
    selected: boolean; // Is page selected
};
